import { render, staticRenderFns } from "./PieEchart.vue?vue&type=template&id=65b329ee&scoped=true&"
import script from "./PieEchart.vue?vue&type=script&lang=js&"
export * from "./PieEchart.vue?vue&type=script&lang=js&"
import style0 from "./PieEchart.vue?vue&type=style&index=0&id=65b329ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b329ee",
  null
  
)

export default component.exports